import { Link } from "react-router-dom";
import { Mail, Phone, MapPin } from "lucide-react";

const SOCIALS = [
  { label: "LinkedIn", url: "https://linkedin.com/company/quadrimtech/" },
  { label: "Facebook", url: "https://facebook.com/Quadrimtech/" },
  { label: "Instagram", url: "https://instagram.com/quadrim.tech/" },
];

const NAV = [
  { label: "Home", to: "/", slug: "home" },
  { label: "Services", to: "/services", slug: "services" },
  { label: "Cisco Partner", to: "/cisco-partner", slug: "cisco" },
  { label: "About", to: "/about", slug: "about" },
  { label: "Work", to: "/work", slug: "work" },
  { label: "Contact", to: "/contact", slug: "contact" },
];

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-base border-t border-white/10">
      <div className="mx-auto max-w-[1600px] px-6 md:px-10 py-16 md:py-20">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10">
          <div className="lg:col-span-4">
            <Link to="/" className="flex items-center gap-2 w-fit">
              <span className="h-3 w-3 rounded-full bg-accent" />
              <span className="font-heading font-extrabold tracking-tight text-lg uppercase">
                Quadrim<span className="text-accent">.</span>
              </span>
            </Link>
            <p className="mt-5 text-[#A1A1AA] max-w-xs leading-relaxed">
              The technology partner for companies who refuse to settle. Managed
              IT and custom software, engineered without compromise.
            </p>
          </div>

          <div className="lg:col-span-3">
            <p className="font-mono text-xs uppercase tracking-[0.2em] text-[#71717A] mb-5">Explore</p>
            <ul className="flex flex-col gap-3">
              {NAV.map((n) => (
                <li key={n.to}>
                  <Link
                    data-testid={`footer-nav-${n.slug}`}
                    to={n.to}
                    className="link-underline text-[#A1A1AA] hover:text-white transition-colors duration-300"
                  >
                    {n.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-3">
            <p className="font-mono text-xs uppercase tracking-[0.2em] text-[#71717A] mb-5">Contact</p>
            <ul className="flex flex-col gap-4 text-[#A1A1AA]">
              <li>
                <a data-testid="footer-email" href="mailto:contact@quadrimtech.com" className="flex items-center gap-3 hover:text-white transition-colors duration-300">
                  <Mail className="h-4 w-4 text-accent" /> contact@quadrimtech.com
                </a>
              </li>
              <li>
                <a data-testid="footer-phone" href="tel:+19493138186" className="flex items-center gap-3 hover:text-white transition-colors duration-300">
                  <Phone className="h-4 w-4 text-accent" /> +1 949 313 8186
                </a>
              </li>
              <li className="flex items-start gap-3">
                <MapPin className="h-4 w-4 text-accent mt-1 shrink-0" />
                <span className="leading-relaxed">1968 S Coast Hwy #1363, Laguna Beach, CA, USA</span>
              </li>
            </ul>
          </div>

          <div className="lg:col-span-2">
            <p className="font-mono text-xs uppercase tracking-[0.2em] text-[#71717A] mb-5">Follow</p>
            <ul className="flex flex-col gap-3">
              {SOCIALS.map((s) => (
                <li key={s.label}>
                  <a
                    data-testid={`social-${s.label.toLowerCase()}`}
                    href={s.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="link-underline text-[#A1A1AA] hover:text-white transition-colors duration-300"
                  >
                    {s.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="mx-auto max-w-[1600px] px-6 md:px-10 py-8 flex flex-col md:flex-row items-center justify-between gap-4 font-mono text-[11px] uppercase tracking-[0.15em] text-[#71717A]">
          <span>© {new Date().getFullYear()} Quadrim Tech — All rights reserved</span>
          <span className="flex items-center gap-2">
            <span className="h-2 w-2 rounded-full bg-accent animate-pulse" />
            Available for new projects
          </span>
        </div>
      </div>
    </footer>
  );
}
